var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _g2, _path1, _path10, _g3, _g4, _ellipse, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoorders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 186,
    viewBox: "0 0 153 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4854 111.662V161.005L76.4673 185.676V136.229L25.4854 111.662Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.4854 111.662V161.005L76.4673 185.676V136.229L25.4854 111.662Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.45 111.662V161.005L76.4678 185.676V136.229L127.45 111.662Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.45 111.662V161.005L76.4678 185.676V136.229L127.45 111.662Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9763 123.945L25.4854 111.661L76.4673 87.2773V136.228L50.9763 123.945Z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.9763 123.945L25.4854 111.661L76.4673 87.2773V136.228L50.9763 123.945Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4678 87.2773V136.228L127.45 111.661L76.4678 87.2773Z",
    fill: "#909090"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.4678 87.2773V136.228L127.45 111.661L76.4678 87.2773Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.452 87.2772L50.989 99.3822L25.511 111.661L0 99.3822L51.683 75.1582L76.452 87.2772Z",
    fill: "#909090"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.452 87.2772L50.989 99.3822L25.511 111.661L0 99.3822L51.683 75.1582L76.452 87.2772Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M152.92 99.558L127.442 87.279L101.963 75L76.4521 87.279L127.449 111.753L152.92 99.558Z",
    fill: "#909090"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.92 99.558L127.442 87.279L101.963 75L76.4521 87.279L127.449 111.753L152.92 99.558Z",
    fill: "white"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.467 136.311L50.989 124.033L25.511 111.754L0 124.033L51.683 148.256L76.467 136.311Z",
    fill: "#909090"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.935 123.696L127.457 135.975L101.978 148.254L76.4668 135.975L127.449 111.66L152.935 123.696Z",
    fill: "#909090"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.935 123.696L127.457 135.975L101.978 148.254L76.4668 135.975L127.449 111.66L152.935 123.696Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.467 136.311L50.989 124.033L25.511 111.754L0 124.033L51.683 148.256L76.467 136.311Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 92.5,
    cy: 24,
    rx: 24.5,
    ry: 24,
    fill: "#5070DE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 31C53.5 21.5725 53.5 16.8575 56.43 13.93C59.36 11.0025 64.0725 11 73.5 11H78.5C87.9275 11 92.6425 11 95.57 13.93C98.4975 16.86 98.5 21.5725 98.5 31V41C98.5 50.4275 98.5 55.1425 95.57 58.07C92.64 60.9975 87.9275 61 78.5 61H73.5C64.0725 61 59.3575 61 56.43 58.07C53.5025 55.14 53.5 50.4275 53.5 41V31Z",
    stroke: "#5070DE",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66 31H86M66 41H78.5",
    stroke: "#5070DE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoorders);
export default __webpack_public_path__ + "static/media/noorders.ea6731253b5c90878eba30ef8edc8d03.svg";
export { ForwardRef as ReactComponent };